import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // For handling UTC time
import timezone from 'dayjs/plugin/timezone'; // For handling timezones

dayjs.extend(utc);
dayjs.extend(timezone);

interface DateTimeFormatterProps {
  timestamp: string;
  invalidDateText?: string;
}

const DateTimeFormatter: React.FC<DateTimeFormatterProps> = ({ timestamp, invalidDateText }) => {
  // Parse the ISO date string
  const parsedDate = dayjs(timestamp).tz(dayjs.tz.guess());

  const validateDate = parsedDate.isValid();

  const formattedDate = parsedDate.format('MM/DD/YY'); // Example: "June 5, 2024 5:59 PM"

  if (!validateDate && invalidDateText) {
    return <span>{invalidDateText}</span>;
  } else {
    return <span>{formattedDate}</span>;
  }
};

export default DateTimeFormatter;
